import { useTranslation } from 'react-i18next'

import {
  USER_STATUS_CODE_BLOCKED,
  USER_STATUS_CODE_IMPORTED,
} from '../../../../../constants/user'
import { ConfirmationModal } from '../../../../Confirmation'
import { useUserProfileContext } from '../../../../User'
import { USER_PROFILE_PAGE_HEADER_FOOTER_ACTION } from '../../UserProfilePageHeaderFooter.constants'

import {
  QA_NAME_USER_PROFILE_PAGE_STATUS_ACTION_CONFIRMATION,
  USER_PROFILE_PAGE_STATUS_ACTIONS_CONFIRMATION,
} from './useUserProfilePageStatusActions.constants'

export function useUserProfilePageStatusActions({
  handleOpenEditAddressModal,
  handlePerformMassAction,
  handleUpdateStatus,
}) {
  const { t } = useTranslation()

  const { handleCloseModal, setModal, userData } = useUserProfileContext()

  function handleShowConfirmModal({ action, onSubmit }) {
    const { descriptionKey, submitTextKey } =
      USER_PROFILE_PAGE_STATUS_ACTIONS_CONFIRMATION[action]

    setModal(
      <ConfirmationModal
        actionButtonsProps={{ submitText: t(submitTextKey) }}
        description={t(descriptionKey)}
        qaName={QA_NAME_USER_PROFILE_PAGE_STATUS_ACTION_CONFIRMATION}
        onCancel={handleCloseModal}
        onSubmit={onSubmit}
      />
    )
  }

  function handleClickApproveRegistration() {
    handleShowConfirmModal({
      action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.approveRegistration,
      onSubmit: () =>
        handlePerformMassAction({
          action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.approveRegistration,
        }),
    })
  }

  function handleClickArchive() {
    handleShowConfirmModal({
      action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.archive,
      onSubmit: () =>
        handlePerformMassAction({
          action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.archive,
        }),
    })
  }

  function handleClickBlock() {
    handleShowConfirmModal({
      action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.block,
      onSubmit: () => handleUpdateStatus(USER_STATUS_CODE_BLOCKED),
    })
  }

  function handleClickRestore() {
    handleShowConfirmModal({
      action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.restore,
      onSubmit: () =>
        handlePerformMassAction({
          action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.restore,
          // A restored inhabitant gets re-linked to a flat; staff has none.
          onSuccess: userData.isStaff ? undefined : handleOpenEditAddressModal,
        }),
    })
  }

  function handleClickUnblock() {
    handleShowConfirmModal({
      action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.unblock,
      onSubmit: () => handleUpdateStatus(USER_STATUS_CODE_IMPORTED),
    })
  }

  return {
    handleClickApproveRegistration,
    handleClickArchive,
    handleClickBlock,
    handleClickRestore,
    handleClickUnblock,
  }
}
